import { render, staticRenderFns } from "./AuctionsListDashboard.vue?vue&type=template&id=0aeed472&"
import script from "./AuctionsListDashboard.vue?vue&type=script&lang=js&"
export * from "./AuctionsListDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports